module.exports = __webpack_public_path__ + "ddff7d4507e7839bb9cafac9ef704b86.jpg";